module.exports = "/images/logo-light-icon.png?94bf1eac2235999eaf044bdf091fdf6c";